import { styled } from "@material-ui/core";
import React from "react";

type Props = {
  className?: string;
  aroma: {
    title: string;
    icon: {
      url: string;
    };
  };
};

export const IconImg = styled("img")(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  marginRight: "4px"
}));

export default function OilAromaIcon({ className, aroma }: Props) {
  if (!aroma.icon?.url) {
    return null;
  }
  return (
    <IconImg alt={aroma.title} src={aroma.icon.url} className={className} />
  );
}
